import React from 'react'
import styled from '@emotion/styled'
import {CallToBookAnchor} from 'components/CallToBook/CallToBookAnchor'

import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/src/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {AccommodationPageLink} from '../AccommodationPageLink'

const ContentWrapper = styled.div`
  background-color: ${cssTheme.colors.background.brand.tertiary};
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s400};

  &.--is-desktop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
  }
`

interface Props {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  isMobile?: boolean
}
export const AnchorLabel = ({onClick, isMobile = false}: Props) => {
  if (isMobile)
    return (
      <ContentWrapper data-id="selected_hotel_banner" onClick={onClick}>
        <Text variant="labelS" colorPath="content.brand.primary">
          <FormattedMessageWrapper
            defaultMessage="Continue with your selected hotel"
            id="continueWithSelectedHotel"
          />
        </Text>
      </ContentWrapper>
    )
  return (
    <AccommodationPageLink>
      <ContentWrapper className="--is-desktop" data-id="selected_hotel_banner">
        <Box flex="1" padding="s300" paddingLeft="s600">
          <Text variant="labelM" colorPath="content.brand.primary">
            <FormattedMessageWrapper
              defaultMessage="Continue with your selected hotel"
              id="continueWithSelectedHotel"
            />
          </Text>
        </Box>
        <CallToBookAnchor />
      </ContentWrapper>
    </AccommodationPageLink>
  )
}
